// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a9f4b6c","952":"c9761a80"}[chunkId] + ".chunk.js";
};